module.exports = __webpack_public_path__ + "static/img/word.a4af5c95.png";